import React from "react";
import styled from "styled-components";
import chroma from "chroma-js";
import { observer } from "mobx-react";
import { withState } from "recompose";

import { toggleOutline, undo, redo } from "../canvas/store";
import user, { logout } from "../user/index";
import { Modals } from "./editor";
import { startPreview } from "./index";
import { connectStreamLabs } from "../spreadsheet/providers/streamlabs";

import * as Icons from "../reusable/icons";
import * as Colors from "../reusable/colors";
import { Divider } from "../reusable/layout";
import { HeaderAction, ActionIcon } from "../reusable/components";

export const headerHeight = 110;

const ActionLabel = styled.span`text-transform: uppercase;`;

const Action = ({ label, Icon, onClick }) => (
  <HeaderAction onClick={onClick}>
    <ActionIcon>
      <Icon />
    </ActionIcon>
    <Divider h="8px" />
    <ActionLabel>{label}</ActionLabel>
  </HeaderAction>
);

const Header = styled.header`
  background-color: ${Colors.primary};
  max-height: ${headerHeight}px;
  min-height: ${headerHeight}px;
  flex: 0 0 ${headerHeight}px;
  padding: 10px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const HeaderCanvas = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const HeaderUser = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const ActionWithAddon = styled.div`position: relative;`;

const AddonUI = styled.ul`
  background-color: ${Colors.primary};
  position: absolute;
  top: 65px;
  left: -15px;
  right: -15px;
  z-index: 50;
  border-color: rgba(0, 0, 0, 0.24);
  border-style: solid;
  border-radius: 0px 0px 5px 5px;
  border-width: 0px 1px 1px 1px;
`;

const Arrow = styled.li`text-align: center;`;

const AddonItem = styled.li`
  padding: 10px 15px;
  cursor: pointer;
  font-weight: ${p => p.active && "bold"};
  &:hover {
    background-color: ${chroma(Colors.primary)
      .darken(0.4)
      .hex()};
  }
  text-decoration: ${p => p.action && "underline"};
  width: 85px;
  overflow: hidden;
  word-wrap: break-word;
`;

const Addon = p => {
  return (
    p.p && (
      <AddonUI>
        <Arrow>
          <Icons.CaretDown />
        </Arrow>
        {p.children}
      </AddonUI>
    )
  );
};

// const ScenesAddon = observer(p => (
//   <Addon p={p.p} onClick={p.close}>
//     {user.listScenes.map(s => (
//       <AddonItem
//         key={s.id}
//         active={s.id === user.currentScene}
//         onClick={() => {
//           changeScene(s.id);
//           p.close();
//         }}>
//         {s.label}
//       </AddonItem>
//     ))}
//     <AddonItem
//       action
//       onClick={() => {
//         p.close();
//         newScene();
//       }}>
//       New
//     </AddonItem>
//   </Addon>
// ));

const login = () => {
  window.open("/popup.html", "name", "height=585,width=400");
};

const enhance = withState("addon", "setAddon", false);
export default observer(
  enhance(({ showModal, addon, setAddon }) => {
    return (
      <Header>
        <HeaderCanvas>
          <Action onClick={undo} Icon={Icons.Undo} label="undo" />
          <Divider w="25px" />
          <Action onClick={redo} Icon={Icons.Redo} label="redo" />
          <Divider w="25px" />
          <Action onClick={toggleOutline} Icon={Icons.Outline} label="outline" />
          <Divider w="25px" />
          <Action onClick={startPreview} Icon={Icons.Preview} label="preview" />
          <Divider w="25px" />
          <Action
            onClick={() => showModal(Modals.KeyMap)}
            Icon={Icons.Keyboard}
            label="Shortcuts"
          />
        </HeaderCanvas>
        {user.id ? (
          <HeaderUser>
            <Action onClick={() => showModal(Modals.Scenes)} Icon={Icons.Scene} label="Scenes" />
            <Divider w="25px" />
            <Action
              onClick={() => showModal(Modals.Spreadsheet)}
              Icon={Icons.Table}
              label="Database"
            />
            <Divider w="25px" />
            <Action
              onClick={() => showModal(Modals.Studio)}
              Icon={Icons.Dashboard}
              label="Studio"
            />
            <Divider w="25px" />
            <Action onClick={() => showModal(Modals.Export)} Icon={Icons.Export} label="Export" />
            <Divider w="25px" />
            <ActionWithAddon>
              <Action
                Icon={Icons.UserCircle}
                label={user.name}
                onClick={() => setAddon(s => s !== "user" && "user")}
              />
              <Addon p={addon === "user"}>
                <AddonItem
                  action
                  onClick={() => {
                    logout();
                    setAddon(false);
                  }}>
                  Logout
                </AddonItem>
                <AddonItem
                  action
                  onClick={() => {
                    connectStreamLabs();
                    setAddon(false);
                  }}>
                  Streamlabs
                </AddonItem>
              </Addon>
            </ActionWithAddon>
          </HeaderUser>
        ) : (
          <HeaderUser>
            <Action Icon={Icons.UserCircle} label={"login"} onClick={login} />
          </HeaderUser>
        )}
      </Header>
    );
  })
);



// WEBPACK FOOTER //
// ./src/layout/header.js